import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.list-report-access-secondary-categories.ReportAccessSecondaryCategoryListView`

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage:
      '{pluralSecondaryOrgCategoryLabel} in {primaryCategoryName}',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search...',
  },
  searchAriaLabel: {
    id: `${scope}.searchAriaLabel`,
    defaultMessage: 'Search {pluralSecondaryOrgCategoryLabel}',
  },
  selectAllLabel: {
    id: `${scope}.selectAllLabel`,
    defaultMessage: 'Select all {pluralSecondaryOrgCategoryLabel}',
  },
  allSelectedLabel: {
    id: `${scope}.allSelectedLabel`,
    defaultMessage: 'All {pluralSecondaryOrgCategoryLabel} are selected',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'No {pluralSecondaryOrgCategoryLabel} available',
  },
  emptyStateContent: {
    id: `${scope}.emptyStateContent`,
    defaultMessage:
      "This {singularPrimaryOrgCategoryLabel} doesn't seem to have any {pluralSecondaryOrgCategoryLabel}.",
  },
})
